<form nz-form class="form" nzLayout="vertical">
  <div class="add-user-tabs">
    <nz-tabset>
      <nz-tab nzTitle="Manual Add"
        ><app-manually [roleList]="roleList$" [isLoading]="isOptionsLoading$"
      /></nz-tab>
      <nz-tab nzTitle="Import Users"
        ><app-import-users
          [roleList]="roleList$"
          [isLoading]="isOptionsLoading$"
      /></nz-tab>
    </nz-tabset>
  </div>
</form>
